import { styledByTheme } from './../../../../themes/architecture/styled-by-theme';
import { RedTigerWidgetFrameContainerDefaultBox } from './red-tiger-widget-frame-container.default.box';

export const RedTigerWidgetFrameContainerBox = styledByTheme(RedTigerWidgetFrameContainerDefaultBox)
    .apply();